import { render, staticRenderFns } from "./information.vue?vue&type=template&id=6991a1fe&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"
import style0 from "./information.vue?vue&type=style&index=0&id=6991a1fe&lang=scss&scoped=true"
import style1 from "./information.vue?vue&type=style&index=1&id=6991a1fe&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6991a1fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6991a1fe')) {
      api.createRecord('6991a1fe', component.options)
    } else {
      api.reload('6991a1fe', component.options)
    }
    module.hot.accept("./information.vue?vue&type=template&id=6991a1fe&scoped=true", function () {
      api.rerender('6991a1fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/equipment/information.vue"
export default component.exports